export const HOVER_TIMEOUT = 500;
